// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".digitWrapper--3GzCiCPK {\n  width: 100%;\n  position: relative;\n  display: flex;\n}\n.digitContainer--2VBEXmLF {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  overflow-y: hidden;\n  font-family: arial;\n}\n\n.digitContainer_custom--12hIpJmG {\n  gap: 12px;\n}\n\n.digitCell--3H6qJf1T {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  box-sizing: border-box;\n}\n.digitSubBox---ulvVhtM {\n  transform: translateY(0);\n}\n\n.digitBox--24mqUNoE {\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.digitDivider--1v3NpSJc {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"digitWrapper": "digitWrapper--3GzCiCPK",
	"digitContainer": "digitContainer--2VBEXmLF",
	"digitContainer_custom": "digitContainer_custom--12hIpJmG",
	"digitCell": "digitCell--3H6qJf1T",
	"digitSubBox": "digitSubBox---ulvVhtM",
	"digitBox": "digitBox--24mqUNoE",
	"digitDivider": "digitDivider--1v3NpSJc"
};
export default ___CSS_LOADER_EXPORT___;
